import React from 'react';
import { Container } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import { SchoolList } from '../../containers/SchoolList/SchoolList';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { angularizeWithProviders } from '../../../shared/providers';

const NgzTeamsPage = observer(() => {
  const entityId = loggedInUserDataStore.getEntityId();

  return (
    <Container>
      <SchoolList entityId={entityId} />
    </Container>
  );
});

angularizeWithProviders(NgzTeamsPage, 'ngzTeamsPage', {});

export { NgzTeamsPage };
